export default __webpack_public_path__ + "static/media/logoTransparent.75202e17.png";